module.exports = __webpack_public_path__ + "img/01.d424557c.png";